import { EQuestionActionsTypes, IStep } from '@cian/frontend-request-form-widget';

import { number, object, ref, string } from 'yup';

import { ExtendedFieldType } from '../extendedFieldType';

import { DEAL_DATE_STEP } from './dealDate';

export const FREE_APPOINTMENT_OBJECT_PAGE: IStep = {
  code: 'freeAppointmentObjectPage',
  question: {
    code: 'freeAppointmentObjectQuestion',
    title: 'Укажите параметры объекта',
    fields: [
      {
        type: ExtendedFieldType.GeoSuggest,
        name: 'geo',
        label: 'Местоположение',
        placeholder: 'Город, адрес, метро, район или шоссе',
      },
      {
        type: ExtendedFieldType.Price,
        name: 'priceFrom',
        unit: '₽',
        prefix: 'от',
        label: 'Цена',
        size: {
          xs: 12,
          m: 6,
        },
      },
      {
        type: ExtendedFieldType.Price,
        name: 'priceTo',
        unit: '₽',
        prefix: 'до',
        label: '\u00A0',
        size: {
          xs: 12,
          m: 6,
        },
      },
      {
        type: ExtendedFieldType.Float,
        name: 'areaFrom',
        unit: 'м²',
        prefix: 'От',
        label: 'Площадь',
        size: {
          xs: 12,
          m: 6,
        },
      },
      {
        type: ExtendedFieldType.Float,
        name: 'areaTo',
        unit: 'м²',
        prefix: 'До',
        label: '\u00A0',
        size: {
          xs: 12,
          m: 6,
        },
      },
    ],
    actions: [{ type: EQuestionActionsTypes.NextQ, text: 'Далее' }],
    validation: object().shape(
      {
        geo: string().when(['areaFrom', 'areaTo', 'priceFrom', 'priceTo'], {
          is: (...fields: unknown[]) => fields.every(field => field == null),
          then: string().required('Укажите значение поля'),
          otherwise: string(),
        }),
        areaFrom: number().when(['geo', 'areaTo', 'priceFrom', 'priceTo'], {
          is: (...fields: unknown[]) => fields.every(field => field == null),
          then: number().required('Укажите значение поля'),
          otherwise: number(),
        }),
        areaTo: number()
          .when(['geo', 'areaFrom', 'priceFrom', 'priceTo'], {
            is: (...fields: unknown[]) => fields.every(field => field == null),
            then: number().required('Укажите значение поля'),
          })
          .when('areaFrom', {
            is: (areaFrom: number) => areaFrom != null,
            then: number().min(ref('areaFrom'), 'Некорректно указано значение'),
          }),
        priceFrom: number().when(['geo', 'areaFrom', 'areaTo', 'priceTo'], {
          is: (...fields: unknown[]) => fields.every(field => field == null),
          then: number().required('Укажите значение поля'),
          otherwise: number(),
        }),
        priceTo: number()
          .when(['geo', 'areaFrom', 'areaTo', 'priceFrom'], {
            is: (...fields: unknown[]) => fields.every(field => field == null),
            then: number().required('Укажите значение поля'),
            otherwise: number(),
          })
          .when('priceFrom', {
            is: (priceFrom: number) => priceFrom != null,
            then: number().min(ref('priceFrom'), 'Некорректно указано значение'),
          }),
      },
      [
        ['geo', 'areaFrom'],
        ['geo', 'areaTo'],
        ['geo', 'priceFrom'],
        ['geo', 'priceTo'],
        ['areaFrom', 'areaTo'],
        ['priceFrom', 'priceTo'],
        ['priceFrom', 'areaFrom'],
        ['priceFrom', 'areaTo'],
        ['areaTo', 'priceTo'],
        ['areaFrom', 'priceTo'],
      ],
    ),
  },
  nextStep: [
    {
      conditions: [],
      nextStepCode: DEAL_DATE_STEP.code,
    },
  ],
};
